'use strict';

var SearchSummaryController = function SearchSummaryController($scope, currentStateCriteriaService, searchSummaryService) {
  $scope.MAX_VALUE_SYMBOLS = 150;
  $scope.visibleRules = [];
  function calculateList(searchRules) {
    $scope.visibleRules = searchSummaryService.getVisibleRules(searchRules);
  }
  $scope.calculateMultiValue = function (arr) {
    return Array.isArray(arr) && arr.join(', ');
  };
  $scope.getVisibleValueFromCombobox = function (operand) {
    return operand.dropdownVisibleValue;
  };
  $scope.onSearchChange = function () {
    currentStateCriteriaService.getSearchCriteriaRulesForRsqlQuery().then(calculateList);
  };
};
SearchSummaryController.$inject = ['$scope', 'CurrentStateCriteriaService', 'SearchSummaryService'];
module.exports = SearchSummaryController;